import Axios from 'axios';
import Cookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';

import {
	SET_CURRENT_USER,
	IS_ADMIN_USER
} from './types';

// Actions
import { get_global_data } from './globalActions';
import { check_user_staff } from './staffsActions';

const cookies = new Cookies ();

// set logged user
export const user_set_current = (store, decoded) => {
	const locale = navigator.language;
	const [language] = locale.split('-');
	localStorage.setItem('language', language);

	const global_data = {
		app: process.env.REACT_APP_ALIAS,
		language: language,
		organization: decoded.organization
	}
	store.dispatch(get_global_data(global_data));

	return {
		type: SET_CURRENT_USER,
		payload: decoded
	}
}

// log user out
export const auth_token_remove = () => dispatch => {
	// const cookies = new Cookies ();
	process.env.REACT_APP_RUNTIME === 'Production' || process.env.REACT_APP_RUNTIME === 'Test' ?
		cookies.remove (process.env.REACT_APP_JWT_KEY, {
				path: '/', 
				domain: '.percepthor.com'}) :
		cookies.remove (process.env.REACT_APP_JWT_KEY, {
				path: '/', 
				domain: '.localhost.com'});
	
	// remove auth header for future requests
	localStorage.clear();
	window.location.href = process.env.REACT_APP_LOGIN;
	auth_token_set (null);
	dispatch (user_set_current ({}));
};

// check for user token
export const user_token_check = (store) => {
	let jwt = cookies.get (process.env.REACT_APP_JWT_KEY);

	if (jwt) {
		let decoded = jwt_decode (jwt);
		auth_token_set (jwt);           // set auth token header auth
		store.dispatch (user_set_current (store, decoded));

		const authURL = process.env.REACT_APP_SERVER_URL + '/api/users/auth';
		Axios.get(authURL)
		.then(() => {
			// Manage user auth (main) request
			store.dispatch(check_user_admin());
			store.dispatch(check_user_staff({ organization: decoded.organization, user: decoded.user }));
		})
		.catch(() => {
			// Manage errors
			window.location.href = process.env.REACT_APP_LOGIN;
		});
	}
	else {
		window.location.href = process.env.REACT_APP_LOGIN;
	}
}

// set auth token for each request
const auth_token_set = token => {

	// Apply to every request
	if (token) Axios.defaults.headers.common['Authorization'] = token;
	else delete Axios.defaults.headers.common['Authorization'];
	
};

// Check admin user (Percpethor)
export const check_user_admin = () => dispatch => {
	const url = `${process.env.REACT_APP_SERVER_URL}/api/users/admin/check`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch({
			type: IS_ADMIN_USER,
			payload: true
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: IS_ADMIN_USER,
			payload: false
		});
	})
}
